export class SecureTokenReq {
  salemMid!: string;
}
